import { createSlice, Reducer } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash-es';
import { updateOkrReviewCycles } from './actions';
import { storeName, okrReviewCyclesInitialState } from './config';
import addCommonCases from '../addCommonCases';

export * from './interfaces';
export * from './actions';
export * from './selectors';

const reviewCycles = createSlice({
  name: storeName,
  initialState: cloneDeep(okrReviewCyclesInitialState),
  reducers: {},
  extraReducers: (builder) => {
    addCommonCases(builder, okrReviewCyclesInitialState)
      .addCase(updateOkrReviewCycles.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateOkrReviewCycles.fulfilled, (state, { payload }) => {
        state.items = payload;
        state.loading = false;
      });
  },
});

export default reviewCycles.reducer as Reducer<
  typeof okrReviewCyclesInitialState
>;
